import { render, staticRenderFns } from "./generateData.vue?vue&type=template&id=38e56976&scoped=true"
import script from "./generateData.vue?vue&type=script&lang=js"
export * from "./generateData.vue?vue&type=script&lang=js"
import style0 from "./generateData.vue?vue&type=style&index=0&id=38e56976&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e56976",
  null
  
)

export default component.exports